import { animationFrameScheduler, interval } from "rxjs";
import { map, scan, filter } from "rxjs/operators";

export function createTicker(pause) {
  pause = pause || (() => true);
  const ticker$ = interval( /* 1000 / 60 */0, animationFrameScheduler ).pipe(
    map(() => ({
      time: Date.now(),
      delta: null
    })),
    scan((previous, current) => ({
      time: current.time,
      delta: (current.time - previous.time) / 1000
    })),
    filter(pause)
  )
  return ticker$
}